import React from "react";
import * as PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
//import classNames from 'classnames';
import styleConstants from "../../styleConstants";

const useStyles = makeStyles({
  container: {
    width: props => props.width,
    backgroundColor: props => props.backgroundColor,
    borderTop: `2px solid ${styleConstants.colors.themeBlue}`
  },
  content: {
    padding: "1rem 2rem 2rem"
  },
  reference: {
    display: "inline-block",
    backgroundColor: styleConstants.colors.themeBlue,
    padding: "0.5rem",
    fontSize: "0.875rem",
    fontWeight: styleConstants.fontWeights.bold,
    textTransform: "uppercase",
    color: "white"
  }
});

const Box = props => {
  const classes = useStyles(props);

  return (
    <div className={classes.container}>
      <div className={classes.reference}>{props.reference}</div>
      <div className={classes.content}>
        {props.title ? (
          <h4 className="figure-title-only">{props.title}</h4>
        ) : null}
        {props.children}
      </div>
    </div>
  );
};

Box.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  backgroundColor: PropTypes.string,
  reference: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired
};

Box.defaultProps = {
  backgroundColor: styleConstants.colors.themeBlueLight
};

export default Box;
